'use strict';

/**
 * Converts the given value to a number.
 *
 * @param prop - The value to convert to a number.
 * @returns The converted number.
 */ function toNumber(prop) {
    return Number(prop);
}

module.exports = toNumber;
